import * as THREE from 'three';
import * as marietta from '../../../../marietta';
import { ThreeView } from "../../../view3d/webcad";
import { IntersectItem } from "../../../view3d/webcad/util";
import { ExtrasType } from "../../../view3d/webcad/WebCadDefines";
import { ItemInfoCollection } from "../../collection";
import { ITEM_MODE_NO } from "../../Constants";
import { ApplyItem } from "./ApplyItem";
import { DataInterface } from "./json/DataInterface";
import { Raycaster } from "./Raycaster";

export class ApplyFitting {

    constructor() {}

    public apply(iteminfo: ItemInfoCollection, fittingData: DataInterface): void {
        const intersect = this.getIntersect(iteminfo);
        if (!intersect) return;

        const parentObj = new IntersectItem().findAncestorByUserData(intersect.object);
        const uid = parentObj?.userData?.modelInfo?.uuid;
        const targetFitting = this.getTargetFitting().find((fitting) => fitting.itemInfo.guid === uid);
        if (!targetFitting) return;

        const clone = targetFitting.itemInfo.clone();
        clone.id = fittingData.itemId;
        clone.text = fittingData.label;
        targetFitting.deleteMe();
        marietta.webcad.WebCADGlobal.itemManager.createItem(clone);
    }

    private getTargetFitting() {
        let itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTING_NO) as marietta.webcad.item.Fitting[];
        // fit01_01 壁は対象外とする
        return itemList.filter((fitting: marietta.webcad.item.Fitting) => fitting.itemInfo.id != 'fit01_01');
    }

    /**
     * 衝突判定で取得したアイテム
     */
    protected getIntersect(iteminfo: ItemInfoCollection): THREE.Intersection {
        const isFittingTargetType = (obj: THREE.Object3D): boolean => {
            return [
                ExtrasType.DOOR, ExtrasType.WIN, ExtrasType.SHUTTER
            ].some((type) => obj.userData?.modelInfo?.typeExtras === type);
        }

        const pos = Raycaster.getPosition(iteminfo);
        const dir = Raycaster.getDirection(iteminfo);

        const raycaster = new THREE.Raycaster(pos, dir);
        const intersectlist = raycaster.intersectObjects(ThreeView.get().wcScene.me.children);

        for (let i = 0; i < intersectlist.length; i++) {
            const object = intersectlist[i]?.object;
            if (!object) continue;

            const parentObj = new IntersectItem().findAncestorByUserData(object);
            if ((parentObj != null) && isFittingTargetType(parentObj)) {
                return intersectlist[i];
            }
        }
    }
}